import type React from "react";
import { use } from "react";
import { AuthContext } from "@/context/AuthContext";
import type { UpdateState } from "@/context/mosaic/TitleMosaicProvider";
import { COMING_SOON_WIDGETS } from "@/services/user-auth/user-roles";
import { HoverCardWrapper } from "@/shared/components/HoverCardWrapper";
import { OfferToUpgrade } from "@/shared/components/OfferToUpgrade";
import { KEY } from "@/shared/constants/keyboard";
import { mapOfferMessage } from "../menu/consts";
import { menuItems } from "../menu/MenuItems/MenuItems";

type NavigationProps = {
	updateState: UpdateState;
};

export const Navigation: React.FC<NavigationProps> = ({ updateState }) => {
	const authContext = use(AuthContext);
	const filteredMenuItem = menuItems(authContext?.roles || [])
		.filter((item) => item.viewId !== "Chat")
		.filter((item) => !item?.disabled);

	return (
		<div className="flex flex-row items-center justify-start flex-wrap">
			{filteredMenuItem.map((item) => (
				<HoverCardWrapper
					key={item.viewId}
					align="start"
					side="right"
					sideOffset={12}
					trigger={
						<button
							disabled={!item.isEnabledByUserRole}
							type="button"
							aria-label={`Open ${item.text}`}
							key={item.viewId}
							className="m-3 cursor-pointer"
							onClick={() => updateState(item.viewId)}
							onKeyDown={(e) => {
								if (e.key === KEY.ENTER) {
									updateState(item.viewId);
								}
							}}
							tabIndex={0}
						>
							{item.text}
						</button>
					}
					content={
						<OfferToUpgrade
							offer={<p>{mapOfferMessage[item.viewId]}</p>}
							buttonText={
								COMING_SOON_WIDGETS.includes(item.viewId) ? null : "Upgrade Now"
							}
						/>
					}
					disabled={!item.isEnabledByUserRole}
				/>
			))}
		</div>
	);
};
